import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTruck, faBox, faHome, faEnvelope, faBarcode, faList, faShoppingCart, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

import api from '../config/api';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const { user } = useAuth();
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('orderId');
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const cartCleared = useRef(false);
  


  useEffect(() => {
    const processPayment = async () => {
      if (orderNumber && !cartCleared.current) {
        try {
          // Önce sipariş detaylarını getir
          const orderData = await api.get(`/orders/details/${orderNumber}`);
          setOrderDetails(orderData.data);

          // Sonra sepeti ve indirim bilgilerini temizle
          cartCleared.current = true;
          await clearCart(); // Bu fonksiyon artık indirim bilgilerini de temizliyor
          console.log('Ödeme başarılı: Sepet ve indirim bilgileri temizlendi');
        } catch (error) {
          console.error('İşlem sırasında hata:', error);
          setError('Sipariş detayları alınamadı');
        } finally {
          setLoading(false);
        }
      }
    };

    processPayment();
  }, [orderNumber, clearCart]);

  const orderDate = new Date().toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  // Tahmini teslimat tarihi (3 iş günü sonrası)
  const deliveryDate = new Date();
  deliveryDate.setDate(deliveryDate.getDate() + 3);
  const estimatedDelivery = deliveryDate.toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="payment-success-page">
      <Container>
        <div className="success-content">
          <div className="success-icon">
            <FontAwesomeIcon icon={faCheckCircle} />
          </div>
          
          <h1>Siparişiniz Başarıyla Oluşturuldu!</h1>
          
          {loading ? (
            <p>Yükleniyor...</p>
          ) : error ? (
            <p className="error">{error}</p>
          ) : (
            <>
              <div className="order-info">
                <p><strong>Sipariş Numarası:</strong> {orderDetails?.order_number}</p>
                <p><strong>Sipariş Tarihi:</strong> {orderDate}</p>
                <p><strong>Tahmini Teslimat:</strong> {estimatedDelivery}</p>
              </div>

              {/* Kargo Bilgileri */}
              {orderDetails?.shipments?.[0] && (
                <div className="shipping-info">
                  <h3><FontAwesomeIcon icon={faTruck} /> Kargo Bilgileri</h3>
                  <p>
                    <FontAwesomeIcon icon={faBarcode} /> <strong>Kargo Takip Numarası:</strong>{' '}
                    <a href={`https://app.geliver.io/tracking/${orderDetails.shipments[0].geliver_shipment_id}`} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="tracking-link">
                      {orderDetails.shipments[0].tracking_number}
                      <FontAwesomeIcon icon={faArrowRight} />
                    </a>
                  </p>
                  <p><strong>Kargo Firması:</strong> {orderDetails.shipments[0].provider_code}</p>
                  {orderDetails.shipments[0].label_url && (
                    <p>
                      <a href={orderDetails.shipments[0].label_url} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                        <FontAwesomeIcon icon={faBox} /> Kargo Etiketini Görüntüle
                      </a>
                    </p>
                  )}
                </div>
              )}

              <div className="customer-info">
                <h3><FontAwesomeIcon icon={faHome} /> Teslimat Bilgileri</h3>
                <p>{orderDetails?.first_name} {orderDetails?.last_name}</p>
                <p>{orderDetails?.address}</p>
                <p>{orderDetails?.district} / {orderDetails?.city}</p>
                <p><FontAwesomeIcon icon={faEnvelope} /> {orderDetails?.email}</p>
              </div>

              <div className="next-steps">
                {user && (
                  <Link to="/orders" className="btn btn-outline-primary me-3">
                    <FontAwesomeIcon icon={faList} /> Siparişlerim
                  </Link>
                )}
                <Link to="/" className="btn continue-shopping-btn">
                  <FontAwesomeIcon icon={faShoppingCart} /> Alışverişe Devam Et
                </Link>
              </div>
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default PaymentSuccess; 